<template>
  <div class="finish-page">
    <img src="@/assets/img/guide/finish.svg" alt="">
    <p class="finish-title">恭喜你已全部配置完成啦~</p>
    <p class="finish-subtitle">下面可以开始给客户演示啦~</p>
    <van-button type="info" @click="skip">前往客户演示模块</van-button>
  </div>
</template>

<script>
export default {
    methods: {
        skip() {
            this.$router.push({ name: 'guideMenu', params: { company: this.$route.params.company, code: 'dy' } });
        }
    }
};
</script>

<style  lang="scss" scoped>
.finish-page{
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding-top: 58px;
    .finish-title{
        height: 30px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #242934;
        line-height: 30px;
        margin-bottom: 12px;
    }
    .finish-subtitle{
        height: 16px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9CA6B9;
        line-height: 16px;
        margin-bottom: 53px;
    }
    .van-button--info{
        width: 200px;
        height: 48px;
        background: #0056FF;
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
        margin: 0 auto;
    }
}
</style>
